import React from 'react';
import { notFound as TEXT } from 'locales/en';

const NotFound = () => {
  return (
    <div className="h-auto md:py-10 lg:py-16 min-h-screen w-screen bg-map bg-no-repeat bg-fixed bg-cover bg-bottom">
      <div className="card border-none px-0 py-0 mx-auto w-screen md:w-6/12 lg:w-5/12 2xl:w-4/12 rounded-md min-h-screen h-80 md:min-h-full">
        <div className="w-full overflow-hidden flex flex-col items-center justify-center h-full rounded-none border-0 pb-6 px-5 lg:px-14">
          <span className="flex flex-row items-center justify-center mb-4">
            <h1 className="text-2xl lg:text-3xl font-semibold text-center text-javelin-gray pr-2">
              {TEXT.header1}
            </h1>
            <h2 className="pl-2 border-l-2 border-javelin-blueGray text-lg lg:text-base text-center text-javelin-gray">
              {TEXT.header2}
            </h2>
          </span>
          <a
            href={process.env.REACT_APP_JAVELIN_ADMIN_URL}
            className="text-javelin-blue-dark text-sm font-bold border-0 focus:outline-none text-center block"
          >
            {TEXT.link}
          </a>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
